import BaseInput from "@/components/UI/Form/Inputs/BaseInput/BaseInput";

const TextInput = ({...props}) => {
    return (
       <BaseInput {...props} inputProps={{type: 'text', ...props.inputProps}} />
    );
};

export default TextInput;